/**
 * Publish state for a question in the bank / on a paper.
 *
 * Matches assessment structure (`QuestionRecord.status`): Ready can go on a
 * live paper; Draft is still being written and is excluded from coverage /
 * points rollups. Surfaces hide Ready chips by default (noise) and only show
 * Draft — see `QuestionBankStatusBadge`.
 *
 * Tones follow package `StatusBadge` / `STATUS_BADGE_TONE_CLASS` (Draft =
 * neutral, Ready = success) — same cadence as the Status Badge gallery.
 */

import type { StatusBadgeTone } from "@exxatdesignux/ui/lib/status-badge-tints"

export const QUESTION_BANK_STATUSES = ["Ready", "Draft"] as const

export type QuestionBankStatus = (typeof QUESTION_BANK_STATUSES)[number]

export const QUESTION_BANK_STATUS_TONE: Record<
  QuestionBankStatus,
  StatusBadgeTone
> = {
  Ready: "success",
  Draft: "neutral",
}

export const QUESTION_BANK_STATUS_ICON: Record<QuestionBankStatus, string> = {
  Ready: "fa-circle-check",
  Draft: "fa-pen",
}

/** What the author sees. Ready means the question is published for an assessment. */
export const QUESTION_BANK_STATUS_LABEL: Record<QuestionBankStatus, string> = {
  Ready: "Published",
  Draft: "Draft",
}

export function normalizeQuestionBankStatus(
  value: string | undefined | null
): QuestionBankStatus {
  return value === "Draft" ? "Draft" : "Ready"
}
